import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'epbt-fa-title-list',
  templateUrl: './epbt-fa-title-list.component.html',
  styleUrls: ['./epbt-fa-title-list.component.scss']
})
export class EpbtFaTitleListComponent implements OnInit {

  constructor() {


  }

  titleData: any;
  private _selectedTitle: string;
  @Input('selectedTitle') set selectedTitle(value: string) {
    // console.log(value);
    this._selectedTitle = value;
    this.selectedTitleChange.emit(this._selectedTitle);
    // console.log(this._selectedTitle);
  }
  get selectedTitle(): string {
    return this._selectedTitle;
  }

  @Input() readonly: boolean;
  // selectedTitle: string;
  @Output() selectedTitleChange = new EventEmitter<any>();


  // onSelectionChange(selectedValue: any) {
  //   this.selectedTitle = selectedValue;
  //   this.selectedTitleChange.emit(this.selectedTitle);
  // }

  ngOnInit() {
    this.titleData = ['', 'Dr.', 'Miss.', 'Mr.', 'Ms.', 'Prof.'];
    //this.titleData = ['Dr.', 'Miss.', 'Mr.', 'Ms.', 'Prof.'];
    //this.selectedTitle = this.titleData[0];
  }

}
